import { render, staticRenderFns } from "./InstitutionalPartnerLayout.vue?vue&type=template&id=970c18b4&scoped=true&"
import script from "./InstitutionalPartnerLayout.vue?vue&type=script&lang=ts&"
export * from "./InstitutionalPartnerLayout.vue?vue&type=script&lang=ts&"
import style0 from "./InstitutionalPartnerLayout.vue?vue&type=style&index=0&id=970c18b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970c18b4",
  null
  
)

export default component.exports